import React, { Component } from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import moment from "moment-timezone";
import tournamentStatus from "../../constants/TournamentStatus";
// import CloseTournamentContainer from "./CloseTournamentContainer";

class SportaTournamentRow extends Component {
  render() {
    let upgrade = this.props.upgrade;
    let tournament = this.props.tournament;
    return (
      <TableRow>
        <TableCell style={{ whiteSpace: "nowrap" }}>
          {moment.unix(upgrade.created).format("dddd D MMMM YYYY HH:mm")}
        </TableCell>
        <TableCell>{tournamentStatus[upgrade.status].name}</TableCell>

        <TableCell>{tournament.name}</TableCell>
        <TableCell>
          {tournament.liveLink && (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={"https://tournify.be/live/" + tournament.liveLink}
            >
              {"https://tournify.be/live/" + tournament.liveLink}
            </a>
          )}
        </TableCell>
        {/* <TableCell>
          <CloseTournamentContainer
            user={this.props.user}
            tournament={tournament}
            tournamentStatus={this.props.tournamentStatus}
            sportaPage={true}
            isTournifyAdmin={this.props.isTournifyAdmin}
          />
        </TableCell> */}
      </TableRow>
    );
  }
}

export default SportaTournamentRow;
